import { events } from './events';
import { Module } from './framework/module';

export class DragModule extends Module {
  async onInit() {
    window.addEventListener('dragover', (event) => this.onDragOver(event));
    window.addEventListener('drop', (event) => this.onDrop(event));
    window.addEventListener('dragenter', (event) => this.onDragEnter(event));
    window.addEventListener('dragleave', (event) => this.onDragLeave(event));
  }

  private onDrop(event: DragEvent) {
    event.stopPropagation();
    event.preventDefault();

    if (event.dataTransfer !== null) {
      const { files } = event.dataTransfer;

      events.emit('open', { files });
    }

    this.removeIsDraggingClassFromBody();
  }

  private onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.ensureIsDraggingClassOnBody();
  }

  private onDragEnter(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.ensureIsDraggingClassOnBody();
  }

  private onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.removeIsDraggingClassFromBody();
  }

  private ensureIsDraggingClassOnBody() {
    if (document.body.classList.contains('is-dragging')) {
      return;
    }

    document.body.classList.add('is-dragging');
  }

  private removeIsDraggingClassFromBody() {
    if (document.body.classList.contains('is-dragging')) {
      document.body.classList.remove('is-dragging');
    }
  }
}
